<template>
  <v-container fluid>
    <h2 class="page-title">Widget Settings</h2>
    <v-layout row wrap class="card-curvey">
      <v-flex xs7>
        <design-form @updatePreview="updatePreview"></design-form>
      </v-flex>
      <v-flex xs5>
        <widget-review :widget-parameters="widgetParameters"></widget-review>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import DesignForm from "../components/publish/designForm.vue";
import widgetReview from "../components/publish/widgetReview.vue";
export default {
  name: "publish",
  components: {
    DesignForm,
    widgetReview,
  },
  data() {
    return {
      widgetParameters: {},
    };
  },
  methods: {
    updatePreview(widgetParameters) {
      this.widgetParameters = widgetParameters;
    },
  },
};
</script>

<style scoped>
.btn-chat {
  display: none;
}
</style>
